import { Color } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { ComponentPropDefinitionUtil, ComponentPropDefinitions, ComponentProps, getColorPropertyAttributes } from "../../base/ComponentProps";
import { PropType } from "../../base/PropType";
import { ImagePropDefinitions } from "../image/ImageProps";

export interface TreeProps extends ComponentProps {
    nodeLeafImageName: ImageName;
    nodeDefaultImageName: ImageName;
    nodeExpandedImageName: ImageName;
    nodeCollapsedImageName: ImageName;
    selectedNodeBackgroundColor: Color;
    selectedNodeColor: Color;
}

let treePropDefs: ComponentPropDefinitions;

export class TreePropDefinitions {
    public static getDefinitions(): ComponentPropDefinitions {
        if (treePropDefs == null) {
            treePropDefs = {
                ...ComponentPropDefinitionUtil.getComponentPropertyDefinitions(),
                nodeLeafImageName: { type: PropType.string, editor: ImagePropDefinitions.imagePropertyEditor, description: "This specifies the default image to use for leaf nodes in this Tree" },
                onChange: { type: PropType.event, category: "Events", addListenerMethod: "addChangeListener", removeListenerMethod: "removeChangeListener", description: "This specifies a function to be called when the a new value is selected in the Tree." },
                selectedNodeBackgroundColor: { type: PropType.string, ...getColorPropertyAttributes("backgroundColor"), description: "This sets which color fills the background of Tree's selected node.", defaultValue: "primary.light" },
                selectedNodeColor: { type: PropType.string, ...getColorPropertyAttributes("color"), description: "This sets which color will be used when rendering foreground of Tree's selected node.", defaultValue: "primary.reverse" },
            }
            ComponentPropDefinitionUtil.populateComponentPropNames(treePropDefs);
        }
        return treePropDefs;
    }
}
